import { partitionByPaper } from "./partitionByPaper";
import { bucketForVisual } from "./labelTemplates";

/**
 * Cenário/visual/bucket recalculados a partir do card atual — é isso que faz
 * o toggle "invertida" trocar a arte na hora. Subgrades incompletas voltam
 * como `error` em vez de estourar a renderização.
 */
const enrichCardLive = (card) => {
  try {
    const part = partitionByPaper(card);
    return {
      card: {
        ...card,
        scenario: part.scenario,
        visual: part.visual,
        paper: part.paper,
      },
      paper: part.paper,
      bucket: bucketForVisual(part.visual),
      error: null,
    };
  } catch (err) {
    return { card, paper: null, bucket: null, error: err };
  }
};

export { enrichCardLive };
